
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.4 17.9a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm4.3 3a1.3 1.3 0 100-2.6 1.3 1.3 0 000 2.6z","fill":"#F9A91E"}}),_c('path',{attrs:{"d":"M29.9 13.5c-.6 0-1 .4-1 1V16h-1.6c-.2-2.1-1-4.1-2.3-5.6l1.1-1.1 1 1c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L25 5.4c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l1 1-1 1.2C22 7.7 20.1 6.9 18 6.7V5.1h1.5c.6 0 1-.4 1-1s-.4-1-1-1h-5c-.6 0-1 .4-1 1s.4 1 1 1H16v1.6c-2.1.2-4.1 1-5.6 2.3L9.3 7.8l1-1c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L5.4 8.9c-.4.4-.4 1 0 1.4.2.2.5.3.7.3.2 0 .5-.1.7-.3l1-1L9 10.4C7.7 12 6.9 13.9 6.7 16H5.1v-1.5c0-.6-.4-1-1-1s-1 .4-1 1v5c0 .6.4 1 1 1s1-.4 1-1V18h1.6c.2 2.1 1 4.1 2.3 5.6l-1.1 1.1-1-1c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4L9 28.6c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-1-1 1.1-1.1c1.6 1.3 3.5 2.1 5.6 2.3V29h-1.5c-.6 0-1 .4-1 1s.4 1 1 1h5c.6 0 1-.4 1-1s-.4-1-1-1H18v-1.6c2.1-.2 4.1-1 5.6-2.3l1.1 1.1-1 1c-.4.4-.4 1 0 1.4.2.2.5.3.7.3.2 0 .5-.1.7-.3l3.5-3.5c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-1 1-1.2-1.1c1.3-1.6 2.1-3.5 2.3-5.6h1.6v1.5c0 .6.4 1 1 1s1-.4 1-1v-5c0-.6-.4-1-1-1zM25.4 17c0 4.6-3.8 8.4-8.4 8.4-4.6 0-8.4-3.8-8.4-8.4 0-4.6 3.8-8.4 8.4-8.4 4.6 0 8.4 3.8 8.4 8.4z","fill":"#47AEA6"}})])
          )
        }
      }
    